import AbstractMatrix from '../abstractMatrix';
import Matrix from '../matrix';

export default class BaseView extends AbstractMatrix() {
    constructor(matrix, rows, columns) {
        super();
        this.matrix = matrix;
        this.rows = rows;
        this.columns = columns;
    }

    static get [Symbol.species]() {
        return Matrix;
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-regression-polynomial/~/ml-matrix/src/views/base.js
// module id = 2
// module chunks = 0